/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Elevenlabs_Connect_TitleInputs */



/**
* | output |
* | --- |
* | "Connect your ElevenLabs account" |
*
* @param {Voice_Manager_Elevenlabs_Connect_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_elevenlabs_connect_title = /** @type {((inputs?: Voice_Manager_Elevenlabs_Connect_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Elevenlabs_Connect_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Connectez votre compte ElevenLabs")
	if (locale === "de") return /** @type {LocalizedString} */ ("ElevenLabs-Konto verbinden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Connetti il tuo account ElevenLabs")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подключите аккаунт ElevenLabs")
	if (locale === "es") return /** @type {LocalizedString} */ ("Conecta tu cuenta de ElevenLabs")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("连接您的 ElevenLabs 账户")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ElevenLabs アカウントを接続")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपना ElevenLabs खाता कनेक्ट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ligue a sua conta ElevenLabs")
	return /** @type {LocalizedString} */ ("Connect your ElevenLabs account")
});